import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { remindStaff } from '@/app/services/HomeService/homeService';
import { Avatar, CircularProgress } from '@material-ui/core';
import { useState } from 'react';
import './room-detail.css';
import { useNavigate } from 'react-router-dom';

const RoomDetail = ({ roomDetail, refresh, setRefresh }) => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const handleClick = () => {
		if (roomDetail.is_enable_activites_reminder) {
			setLoading(true);
			remindStaff(roomDetail.id)
				.then(() => {
					setRefresh(!refresh);
				})
				.finally(() => {
					setTimeout(() => {
						setLoading(false);
					}, 1000);
				});
		} else {
			navigate('/reports-activity', { room: roomDetail.id, date: new Date().toISOString().split('T')[0] });
		}
	};
	return (
		<div className="flex gap-x-16">
			<div className="acitivty-count-wrapper">
				<div className="activity-count flex flex-col items-center">
					<div className="text-pd-2xl font-bold">{roomDetail.total_activity_count}</div>
					<div className="font-semibold text-pd-black">Activities</div>
				</div>
			</div>
			<div className="flex flex-col flex-grow gap-y-16 mt-8">
				<div className="flex text-pd-lg font-bold gap-x-4">
					<Avatar src={roomDetail.thumb} style={{ width: 30, height: 30 }} />
					<div>{roomDetail.name}</div>
				</div>
				<hr color="lightgray" />
				{roomDetail.show_student_label ? (
					<div className="flex items-center gap-x-4">
						{roomDetail.student_needs_activity === 0 ? (
							<Avatar src="assets/images/tick-icon.png" style={{ width: 30, height: 30 }} />
						) : (
							<Avatar src="assets/images/icon.png" style={{ width: 30, height: 30 }} />
						)}
						<div className="flex items-center gap-x-4">
							{roomDetail.student_needs_activity === 0 ? (
								<>
									<span className="font-semibold" style={{ color: '#13A594' }}>
										All students
									</span>
									<div>have activities logged</div>
								</>
							) : (
								<>
									<span className="text-red-900 font-semibold">{roomDetail.student_needs_activity} students</span>
									<div>need activities logged</div>
								</>
							)}
						</div>
					</div>
				) : (
					''
				)}
				<div className="flex justify-between items-center">
					<div className="flex justify-between shrink gap-x-16">
						{roomDetail.activity_count_data.map((item) =>
							item.activity_id in roomDetail.activity_data ? (
								<div className="activity-counts flex gap-x-2 items-center" key={item.activity_id}>
									<img
										// width={25}
										alt="img"
										src={
											item.activity_id === 1
												? 'assets/images/diaper.png'
												: item.activity_id === 3
													? 'assets/images/nap.png'
													: 'assets/images/post.png'
										}
									/>
									{`${item.total} ${roomDetail.activity_data[item.activity_id]?.name || ''}`}
								</div>
							) : (
								''
							)
						)}
					</div>
					<div>
						{loading ? (
							<div className="flex justify-between">
								<CircularProgress size={35} />
							</div>
						) : (
							<CustomButton
								onClick={handleClick}
								variant={!roomDetail.is_enable_activites_reminder ? 'secondary' : 'primary'}
								width={115}
							>
								{!roomDetail.is_enable_activites_reminder ? 'View Details' : 'Remind Staff'}
							</CustomButton>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default RoomDetail;
